module.exports = __webpack_public_path__ + "img/矩形 84@1x.335b46fd.png";